import { Blocks, isEditing } from "@builder.io/sdk-react";

import { Column as UIColumn, Row as UIRow } from "@jti/core-components/components/Row";

import { Placeholder } from "../Placeholder/Placeholder";

import type { RowProps } from "./Row.builder";

import styles from "./Row.module.scss";

export const Row = ({ builderBlock, builderContext, builderComponents, attributes }: RowProps) => {
  const children = builderBlock?.children ?? [];

  if (children.length === 0 && isEditing()) {
    return <Placeholder {...attributes}>Drag and drop Column components here</Placeholder>;
  }

  return (
    <UIRow className={styles.row} {...attributes}>
      {children.filter(Boolean).map((childBlock, index) => {
        const component = childBlock.component;

        if (component?.name !== "Column") {
          return null;
        }

        const desktopWidth = component.options?.desktopWidth ?? 12;
        const tabletWidth = component.options?.tabletWidth ?? desktopWidth;

        return (
          <UIColumn key={childBlock.id ?? index} sm={12} md={tabletWidth} lg={desktopWidth}>
            <Blocks
              blocks={[childBlock]}
              parent={builderBlock?.id}
              path={`children.${index}`}
              context={builderContext}
              registeredComponents={builderComponents}
            />
          </UIColumn>
        );
      })}
    </UIRow>
  );
};
